/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="merchantAccounts.module.ts" />

module Meevo.Plugins.MerchantAccounts {
    class MerchantAccountsController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$translate",
            "$cookies",
            "$q",
            "meevo.components.hostedPage.HostedPageService",
            "meevo.components.common.RoundingService",
            "meevo.plugins.tippy.tippyService"
        ];

        providers: Meevo.Model.MerchantProvider[];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $cookies: angular.cookies.ICookiesService,
            protected $q: ng.IQService,
            protected hostedPageService: Meevo.Components.HostedPage.IHostedPageService,
            protected roundingService: Meevo.Components.Common.IRoundingService,
            protected tippyService: Meevo.Plugins.Tippy.TippyService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.applyParamsToContext(this.contextParams.params);

            this.$scope.$on(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, (event, state, params) => {
                this.applyParamsToContext(params);
            });
        }

        /**
       * Creates the context for editing/adding an item.
       * @return {}
       */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.REGISTER_MERCHANTACCOUNT).then(() => {
                this.busyService.stop();
                this.context = new MerchantAccountsContext(
                    this.appSettings,
                    this.dataService,
                    this.modalService,
                    this.identityService,
                    this.loggingService,
                    this.securityService,
                    this.trackingService,
                    this.busyService,
                    this.$cookies,
                    this.$q,
                    this.$translate,
                    this.hostedPageService,
                    this.securityService,
                    this.roundingService,
                    this.tippyService
                );

                this.context.activate(this.selectedItemId, null, this.asLocationId);

                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };

                // Use translate service to populate field list
                this.context.locationFieldList = [{
                    field: 'ObjectState',
                    label: this.$translate.instant("HEADER_STATUS"),
                    checked: false
                }];

                this.getMerchantProviders();
            }).catch(() => {
                this.busyService.stop();
            });
        }

        getMerchantProviders() {
            if (!this.providers) {
                this.dataService.customMethodData("/api/location/merchantProviders", "GET", null).then((response) => {
                    this.providers = response.data;
                });
            }
        }

        getAuditCriteria() {
            if (!this.context || !this.context.selectedSection) {
                return null;
            }

            return (<any>this.context.selectedSection).customAuditCriteria;
        }

        applyParamsToContext(params: {id: Guid}): void {
            if (params && params.id) {
                this.visualState = Model.MaintenanceFormVisualState.Detail;
                this.selectedItemId = params.id;
            }
        }
    }

    angular.module("meevo.plugins.merchantAccounts")
        .controller("meevo.plugins.merchantAccounts.MerchantAccountsController", MerchantAccountsController);
}
